import styled from '@emotion/styled'
import { Box, Container } from '@material-ui/core'
import MakesBetter from 'components/MakesBetter'
import QueryWrapper from 'components/querywrapper'
import RedSquare from 'components/RedSquare'
import { H2Bold, H3Medium, H4Bold, H6Bold } from 'components/Typography/Basic'
import { mediaQueries } from 'devices'
import { useFetchPage, useLocale } from 'hooks'

const { REACT_APP_STRAPI_API_URL } = process.env

const AffliatePage = () => {
  const { locale } = useLocale()
  const fetcher = () =>
    fetch(
      `${REACT_APP_STRAPI_API_URL}/api/Avax-affliatepage?&locale=${locale}&populate=*`
    ).then(response => response.json())

  const { data: page, isLoading, isError } = useFetchPage(
    ['api/affliate', locale],
    fetcher
  )
  return (
    <QueryWrapper loading={isLoading} error={isError}>
      <Container>
        <AffliateWrapper>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            mt="112.82px"
          >
            <H2Bold className="align-center">{page?.title}</H2Bold>
            <Button
              style={{
                marginTop: '39.82px'
              }}
            >
              {page?.button?.title}
            </Button>
          </Box>
          <Box display="flex" mt="80px" gap="103px" className="steps-wrapper">
            <div>
              <H3Medium>{page?.CTAtext}</H3Medium>
              <GhostButton>{page?.button?.title}</GhostButton>
            </div>
            <div>
              {page?.steps.map((step, index) => (
                <StepCard key={step.id}>
                  <H4Bold className="step-index">{index + 1}</H4Bold>
                  <H6Bold className="step-text">{step.title}</H6Bold>
                </StepCard>
              ))}
            </div>
          </Box>
        </AffliateWrapper>
      </Container>
      <RedSquare />
      <Container>
        <AffliateWrapper>
          <MakesBetter style={{ marginTop: '80px', marginBottom: '120px' }} />
        </AffliateWrapper>
      </Container>
    </QueryWrapper>
  )
}

export default AffliatePage

const AffliateWrapper = styled.div`
  max-width: 1021px;
  margin: auto;

  .steps-wrapper {
    ${mediaQueries.phone} {
      flex-direction: column;
      > :first-child {
        margin-bottom: 60px;
      }
    }
  }
`

const Button = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
  max-width: 268px;
  color: #ffffff;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 160%;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
  letter-spacing: 0.15px;
  background: #e7303c;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  display: block;
  white-space: nowrap;

  ${mediaQueries.phone} {
    max-width: 100%;
    font-size: 16px;
  }
`

const GhostButton = styled(Button)`
  background: transparent;
  color: #e7303c;
  border: 1px solid #e7303c;
  margin-top: 37px;
`

const StepCard = styled.div`
  background: #fafafa;
  padding: 20px;
  margin-bottom: 8px;
  display: flex !important;

  .step-index {
    color: #5e17fe;
  }

  .step-text {
    color: #212540;
    margin-left: 40px;
  }
`
